export interface IncomingOfferLifecycle {
  onEnd(callback: () => void): unknown;
  onUnanswered(callback: () => void): unknown;
}

export type IncomingOfferFilter<TOffer> = (
  offer: TOffer,
) => boolean | Promise<boolean>;

export async function prepareIncomingOffer<
  TOffer extends IncomingOfferLifecycle,
>(
  offer: TOffer,
  filter: IncomingOfferFilter<TOffer> | undefined,
  dismiss: () => void,
): Promise<boolean> {
  let ended = false;
  const handleEnded = () => {
    ended = true;
    dismiss();
  };

  offer.onEnd(handleEnded);
  offer.onUnanswered(handleEnded);

  try {
    if (filter && !(await filter(offer))) {
      return false;
    }
  } catch {
    // Fail-open: exibe a oferta se o filtro do host falhar.
  }

  return !ended;
}
